export default __webpack_public_path__ + "static/media/206.d2b1ccf9.jpg";